<script setup></script>

<template>
	<div class="w-fit select-none whitespace-nowrap border border-crowns-castle-shadow bg-crowns-grey px-1.5 py-0.5 text-crowns-off-white"><slot /></div>
</template>
